__turbopack_context__.v({
  "root": "tweet-in-reply-to-module__Lv55MG__root",
});
